import React from 'react';

export default function LegalNotice() {
        var content = 'All materials appearing on the Qamatz-Website (https://qamatz-mol.de), including photographs, ' + 
                        'images, paintings, and texts are protected by copyright under German and international copyright ' +  
                        'laws and are the intellectual property of L. D. Molinek or the party credited as the provider of the content. ' +
                        'You shall not copy, reproduce, distribute, publish, display, perform, modify, create derivative works, transmit or ' +
                        'in any way exploit any such content, nor may you distribute any part of this content over any network, including ' +
                        'LAN (local area network), sell or offer for it sale or use such content to create any sort of database. ' +
                        'Copying or storing any content, except as provided above, is expressly prohibited without prior permission from ' +
                        'the author of this website. \n';
        content = content.split('\n').map(str => <p> { str } </p>);
        var heading = 'Design & web development: \n';
        heading = heading.split('\n').map(str => <p> { str } </p>);

    return (               
        <div class='legal-notice'>
            <h1 class='mt-5'>Copyright Disclaimer</h1>
            <div class='legal-notice-content'>
                <div class='legal-notice-content-text'>
                    { content }
                </div>
                <div class='legal-notice-heading'>
                    { heading }
                </div>
                <div class='legal-notice-author'>
                    <p>Lukasz Molinek</p>
                    <p>hilbert.mol /at/ vp.pl</p>
                </div>
            </div>
        </div>
    );
}